export const convertToArrayBuffer = (data: unknown) => {
  try {
    return new TextEncoder().encode(JSON.stringify(data));
  } catch (exception) {
    console.error('Err data conversion to ArrayBuffer: ', JSON.stringify(exception));

    return null;
  }
};
